import { useState, useEffect } from "react";
import Wrapper from "./MainContent.style";
import CategoryContainer from "./CategoryContainer";
import PortalSearchBar from "../../Shared/PortalSearchBar";

const MainContent = ({ chartCategories }) => {
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const title = decodeURIComponent(queryParams.get('menutitle'));
        if (title != undefined && title.trim() != '') {
            const rightElement = document.querySelector('.categoryContainer');
            const targetElement = document.querySelector(`#${title}`);
            if (rightElement && targetElement) {
                window.scrollTo(0, targetElement.offsetTop + rightElement.offsetTop + 120);
            }
        }
    }, []);

    return (
        <Wrapper id="rightContainer">
            {/* <PortalSearchBar
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search charts"
            /> */}
            {
                chartCategories?.map(category => <CategoryContainer key={category.displayName} category={category} searchTerm={searchTerm} />)
            }
        </Wrapper>
    );
}

export default MainContent;